
console.log("Custom js is working");
console.log("")
var mega_menu_open = false;

if(window.innerWidth > 640) {
  window.addEventListener("scroll", () => {
    const header = document.querySelector("sticky-header");
  if(request_page_type == 'index') {
    // if(window.pageYOffset > 100 && window.pageYOffset < 950) {
    //   header.setAttribute('hide', true);
    // } else {
    //   header.setAttribute('hide', false);
    // }
  } else {
    // document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
  }
  
    if(window.pageYOffset > 900) {
      if(request_page_type != 'product') {
        // document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
        document.querySelector("sticky-header").style.background = '#ffffff';
    
        header.setAttribute('dark', true);
    
        // document.querySelector('.header__icon--account').style.display = 'none';
      }
    } else{
     if(request_page_type == 'index' && !document.querySelector("sticky-header").classList.contains('search-focused')) {
      //   document.querySelector("sticky-header").style.backdropFilter = 'blur(0px)';
      //  header.style.background = 'transparent';

      //  document.querySelector("sticky-header").style.backdropFilter = 'blur(27px)';
        document.querySelector("sticky-header").style.background = '#ffffff';
    
        header.setAttribute('dark', true);
       
     }
     if(mega_menu_open == false) {
       if(request_page_type == 'index' && !document.querySelector("sticky-header").classList.contains('search-focused')) {
        header.setAttribute('dark', true);
       } else {
         header.setAttribute('dark', true);
       }
       } else {
       header.setAttribute('dark', true);
       }
        // document.querySelector('.header__icon--account').style.display = 'block';
    }
  })
}

// document.querySelectorAll(".menu-drawer__menu-item").forEach((item, index) => {
//   item.addEventListener("click", () => {
//     document.querySelector(".menu-drawer__menu-item[aria-expanded='true']")
//       if(item != item_1) {
//         item_1.closest(".menu-drawer__close-button").click();
//       }
    
//   })
// })

document.querySelectorAll("header-menu details").forEach((item) => {
  item.querySelector('summary').addEventListener('click', (e) => {
    e.preventDefault();
    window.location.href = item.querySelector('summary').getAttribute('data-url');
  })
})


document.querySelectorAll("header-menu details").forEach((item) => {
  item.addEventListener("mouseover", () => {
    document.querySelectorAll("header-menu details").forEach((otheritem) => {
      otheritem.removeAttribute("open", '');
      otheritem.querySelector('summary').setAttribute('aria-expanded', 'false');
    })
    item.setAttribute("open", '');
    item.querySelector('summary').setAttribute('aria-expanded', 'true');

    setTimeout(() => {
      if (item.open) {
        mega_menu_open = true;
      console.log("menu is open");

      const summaryEl = item.querySelector('summary');
      const item_link = summaryEl.getAttribute('data-url');
      const spanEl = summaryEl.querySelector('span');

      // if (item_link && spanEl) {
      //   const item_value = spanEl.innerText;

      //   // Create <a> element
      //   const anchor = document.createElement('a');
      //   anchor.innerText = item_value;
      //   anchor.href = item_link;

      //   // Replace <span> with <a>
      //   spanEl.replaceWith(anchor);

      //   console.log(item_value);
      //   console.log(item_link);
      // }
        document.querySelector("sticky-header").setAttribute("dark", true);
        document.querySelector("body").classList.add("mega-menu-opened");
    } else {
        mega_menu_open = false;
      console.log("menu is closed");
        if(request_page_type == 'index' && window.pageYOffset < 1000 && !document.querySelector("sticky-header").classList.contains('search-focused')) {
          document.querySelector("sticky-header").setAttribute("dark", true);
        } else {
          document.querySelector("sticky-header").setAttribute("dark", true);
        }
        document.querySelector("body").classList.remove("mega-menu-opened");
    }
    }, 50)
  })
})

document.querySelectorAll("header-menu details").forEach((item) => {
  item.querySelector('.mega-menu__content').addEventListener("mouseout", () => {
    item.removeAttribute("open");
    item.querySelector('summary').setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      if (item.open) {
        mega_menu_open = true;
      console.log("menu is open");

      const summaryEl = item.querySelector('summary');
      const item_link = summaryEl.getAttribute('data-url');
      const spanEl = summaryEl.querySelector('span');

      // if (item_link && spanEl) {
      //   const item_value = spanEl.innerText;

      //   // Create <a> element
      //   const anchor = document.createElement('a');
      //   anchor.innerText = item_value;
      //   anchor.href = item_link;

      //   // Replace <span> with <a>
      //   spanEl.replaceWith(anchor);

      //   console.log(item_value);
      //   console.log(item_link);
      // }
        document.querySelector("sticky-header").setAttribute("dark", true);
        document.querySelector("body").classList.add("mega-menu-opened");
    } else {
        mega_menu_open = false;
      console.log("menu is closed");
        if(request_page_type == 'index' && window.pageYOffset < 1000 && !document.querySelector("sticky-header").classList.contains('search-focused')) {
          document.querySelector("sticky-header").setAttribute("dark", true);
        } else {
          document.querySelector("sticky-header").setAttribute("dark", true);
        }
        document.querySelector("body").classList.remove("mega-menu-opened");
    }
    }, 50)
  })
})

document.querySelectorAll(".menu-drawer__menu details").forEach((item) => {
  item.addEventListener("toggle", () => {
    if (item.open) {
      mega_menu_open = true;
      console.log("menu is open");

      const others = Array.from(document.querySelectorAll(".menu-drawer__menu details"))
        .filter(detail => detail !== item);

      others.forEach((other) => {
        if (other.open) {
          let summaryItem = other.querySelector('summary');
          other.removeAttribute("open"); // This closes it without triggering another toggle
          summaryItem.setAttribute('aria-expanded', false);
        }
      });

    } else {
      mega_menu_open = false;
      console.log("menu is closed");
    }
  });
});


if(window.innerWidth <= 640) {
  window.addEventListener("scroll", () => {
    const header = document.querySelector("sticky-header");
    if(request_page_type == 'index') {
      if(window.pageYOffset > 400) {
      
  
      header.setAttribute('dark', true);
      // header.style.backdropFilter = 'blur(27px)';
      header.style.background = '#ffffff';
    } else{
      //  header.style.backdropFilter = 'blur(0px)';
      //   header.style.background = 'transparent';
       
      //    header.setAttribute('dark', false);
      }
    } else if(request_page_type != 'product'){
      header.setAttribute('dark', true);
      // header.style.backdropFilter = 'blur(27px)';
      header.style.background = '#ffffff';
    }
  })
}


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("sticky-header");
  if(request_page_type != 'product') {
     header.setAttribute('dark', true);
    // header.style.backdropFilter = 'blur(27px)';
    header.style.background = '#ffffff';
  } else {
    header.style.background = 'transparent';
  }
});


document.querySelector(".header__icon--menu").addEventListener("click", (e) => {
   const header = document.querySelector("sticky-header");
  setTimeout(() => {
    const status = document.querySelector(".header__icon--menu").getAttribute("aria-expanded");
    if(status == 'true') {
      console.log("menu drawer opened");
      document.querySelector(".custom-header-icons").classList.add("menu-open");
      header.style.removeProperty('backdrop-filter');
      header.style.background = 'transparent';
      header.setAttribute('dark', true);
    } else {
        document.querySelector(".custom-header-icons").classList.remove("menu-open");
      if(request_page_type == 'index') {
         console.log("menu drawer closed");
          header.setAttribute('dark', true);
        //  if(window.pageYOffset > 400) {
        //     header.style.backdropFilter = 'blur(27px)';
        //    header.style.background = '#ffffff54';
        //     header.setAttribute('dark', true);
        //  }
        // header.style.backdropFilter = 'blur(27px)';
           header.style.background = '#ffffff';
            header.setAttribute('dark', true);
      } else {
          // header.style.backdropFilter = 'blur(27px)';
           header.style.background = '#ffffff';
            header.setAttribute('dark', true);
      }
     
    }
  }, 50)
});


// if(request_page_type == 'index') {
//   document.querySelector(".header__heading-logo-wrapper img").style.opacity = '0';
// }


    class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.slider = this.querySelector('[id^="Slider-"]');
      this.nextBtn = this.querySelector('.swiper-button-next');
      this.prevBtn = this.querySelector('.swiper-button-prev');      
  
      if (!this.slider) return;  
      this.initPages();   
  
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      if(window.innerWidth > 989 ) {
        this.addEventListener('mouseenter', this.onHoverNextSlide.bind(this));
        this.addEventListener('mouseleave', this.resetSlider.bind(this));
        
      }

    }  
  
    initPages() {
      this.swiper = new Swiper(this, {
            pagination: {
              el: ".swiper-pagination",
              type: "progressbar",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
          allowTouchMove: true,
          // Navigation arrows
          effect: 'fade',
          speed: 600,
          
        breakpoints: {
          990: {
            allowTouchMove: true,
          },
        },
        });
    }

    
    onHoverNextSlide() {
      this.swiper.slideTo(1, 600);
    }
    
    resetSlider() {
      this.swiper.slideTo(0, 600);
    }

  }

  // window.addEventListener("DOMContentLoaded", () => {
  //   document.querySelector(".swiper-pagination-progressbar-fill").style.transform = "translate3d(0px, 0px, 0px) scaleX(0.5) scaleY(1)";
  // })

  customElements.define('product-card-slider', ProductCardSlider);




  document.querySelectorAll(".mega-menu__list li").forEach((item) => {
    item.addEventListener("mouseover", () => {
      const image_link = item.querySelector("a").getAttribute("data-image-value");
      const menu_title = item.querySelector("a").getAttribute("data-menu-title");
      const link_title = item.querySelector("a").getAttribute("data-link-title");
      const link_url = item.querySelector("a").getAttribute("data-link-url");
      document.querySelector(`.custom-image-card[data-menu='${menu_title}'] img`).src = `${image_link}`;
      document.querySelector(`.custom-image-card[data-menu='${menu_title}']`).href = `${link_url}`;
      document.querySelector(`.custom-image-card[data-menu='${menu_title}'] span`).innerText = `${link_title}`;
    })
  })


  // customjs to trim footer newsletter placeholder text
  if(window.innerWidth < 454) {
    const input_width = document.querySelector("#contact_form .field__input").clientWidth;
    const char_to_show = input_width/5.5;
    const placeholder_text = document.querySelector("#contact_form .field__input").getAttribute("placeholder");
    const truncated_text = placeholder_text.substring(0,char_to_show)+"..";
    document.querySelector("#contact_form .field__input").setAttribute("placeholder", truncated_text);
  }


// custom css for brand and bespoke page
    document.querySelectorAll(".shopify-section-group-footer-group").forEach((section, index) => {
      section.classList.add(`scrolling-footer-section-${index+1}`);
    });

    // document.querySelector(".scrolling-footer-section-1").style.marginTop = document.querySelector(".scrolling-footer-section-1").clientHeight+'px';

if(request_page_type == 'index') {
  document.querySelector('.header__search.hide_on_mobile .search__input').addEventListener("focusin", () => {
    document.querySelector('sticky-header').style.background = 'rgba(255, 255, 255, 1)';
    // document.querySelector('sticky-header').style.backdropFilter = 'blur(27px)';
    document.querySelector('sticky-header').setAttribute('dark', true);
    document.querySelector('sticky-header').classList.add('search-focused');
  });
  
  document.querySelector('.header__search.hide_on_mobile .search__input').addEventListener("focusout", () => {
  if(window.pageYOffset < 900) {
    document.querySelector('sticky-header').style.background = 'rgba(255, 255, 255, 0)';
    document.querySelector('sticky-header').style.backdropFilter = 'blur(0px)';
    document.querySelector('sticky-header').setAttribute('dark', true);
    document.querySelector('sticky-header').classList.remove('search-focused');
  }
  })
}